import React, { useState, useEffect } from "react";
import ImageRadioButton from "../../UIElements/ImageRadioButtons";
import FormButtonStyle4 from "../../UIElements/FormButton";
import FormInputStyle4 from "../../UIElements/FormInput";
import FormInputStyle5 from "../../UIElements/FormInput5";
import Header from "../Header/header";
import callApi from "../../../../utility/apiCaller";
import _ from "lodash";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setAllOffers, setOffers } from "../../../../store/app/appReducer";
import getStateFromPincode from "../../Utils/stateMapperfnction";
import useAddLead from "../../hooks/addLeadtoCRM"

const DurationInput = ({
  years,
  months,
  onYearsChange,
  onMonthsChange,
  error,
}) => {
  return (
    <div className="flex gap-3 box-border w-full">
      <FormInputStyle5
        label="Years"
        type="text"
        value={years}
        onChange={onYearsChange}
        isValid={!error.years}
        errorMessage={"enter valid years"}
      />
      <FormInputStyle5
        label="Months"
        type="text"
        value={months}
        onChange={onMonthsChange}
        isValid={!error.months}
        errorMessage={"enter valid months (0-11)"}
      />
    </div>
  );
};
const indianStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];
export default function ResidentialDetailsForm({
  setCurrentStep,
  setAddressState,
  // leadId = "68b16603596d4397307eccb3"
}) {
  const [formData, setFormData] = useState({
    residenceAddress: "",
    wingFloorFlat: "",
    buildingName: "",
    years: "",
    months: "",
    permanentAddressType: "Owned",
    permanentAddress: "",
    addressLine1: "",
    addressLine2: "",
    pincode: "",
    workAddress1: "",
    workAddress2: "",
    workPincode: "",
  });
  const [ownership, setOwnership] = useState("Owned");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [pincodeValidation, setpincodeValidation] = useState(false);
  const user = useSelector((state) => state.app.user);
  const aaSlice = useSelector((state) => state?.aa);
  let leadId = aaSlice?.internalLeadId;
  const InternalLeadId = aaSlice?.internalLeadId;
  const userData = aaSlice?.userData;
  const [isFormValid, setIsFormValid] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [activeLenders, setActiveLenders] = useState([]);
  const dispatch = useDispatch();
  const [workCity, setWorkCity] = useState("");
  const [workState, setworkState] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [hasOffer, setHasOffer] = useState(false);
  const addLead = useAddLead();
  const [errors, setErrors] = useState({});

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const fetchOffers = async (leadId, jugadResp) => {
    if (!leadId || isFinished) return false;

    try {
      // Step 1: Get base offers  uncommet plz
      // const res = await callApi(
      //   `v1/loan_offer/lead_id/${leadId}`,
      //   "get",
      //   {},
      //   "core",
      //   user.token
      // );

      // if (res.status !== "Success" || !Array.isArray(res.data?.offers)) {
      //   return { success: false, offers: [] };
      // }

      //const baseOffers = res.data.offers;
      const baseOffers = jugadResp.data.offers;
      // Step 2: Get lender success + fail list
      const lenderListRes = await callApi(
        `v1/lender_api_call/${leadId}/get-fail-success-lenders`,
        "post",
        {},
        "loan",
        user.token
      );

      const failedList = lenderListRes.data?.FailList || [];

      let lenderMap = {};
      if (
        lenderListRes.status === "Success" &&
        Array.isArray(lenderListRes.data?.Successlist)
      ) {
        lenderMap = Object.fromEntries(
          lenderListRes.data.Successlist.map((lender) => [
            lender.lender_id,
            lender,
          ])
        );
      }

      // Step 3: Enrich offers with lenderMap
      const enrichedOffers = baseOffers.map((offer) => {
        //const lender = lenderMap[offer.lender_id] || {};
        const lender = {
          otp_page_api_push: false,
          apr: "12-24%",
          kfs_doc: "https://lender-kfs.s3.ap-south-1.amazonaws.com/lnt.pdf",
          penal_charges: " 2% on overdue",
          processing_fee: "3%",
          interest_rate: "11%",
          credit_limit: "15 Lakhs",
          lender_name: "Aditya Birla Capital",
        };
        return {
          ...offer,
          apr: lender.apr ?? "",
          kfs_doc: lender.kfs_doc ?? "",
          credit_limit: lender.web_offer ?? "",
          penal_charges: lender.penal_charges ?? "",
          processing_fee: lender.processing_fee ?? "",
          interest_rate: lender.web_interest ?? null,
          lender_name: lender.lender_name ?? offer.lender_name,
        };
      });

      // Step 4: Sort by priority if available
      const sortedOffers = _.orderBy(enrichedOffers, ["priority"], ["asc"]);

      // Step 5: Apply active lender filter if needed
      const filteredOffers = activeLenders.length
        ? sortedOffers.filter((offer) =>
            activeLenders.some((lender) => lender._id === offer.lender_id)
          )
        : sortedOffers;

      return {
        success: true,
        offers: filteredOffers,
        failedList: failedList,
      };
    } catch (err) {
      console.error("Error in offer fetching", err);
      toast.error("Something went wrong while fetching offers.");
      setIsFinished(true);
      return { success: false, offers: [] };
    }
  };

  useEffect(() => {
    const allValid =
      formData.addressLine1?.trim() &&
      !errors.addressLine1 &&
      formData.addressLine2?.trim() &&
      !errors.addressLine2 &&
      formData.pincode?.trim() &&
      !errors.pincode &&
      city?.trim() &&
      !errors.city &&
      state?.trim() &&
      !errors.state &&
      formData.workAddress1?.trim() &&
      !errors.workAddress1 &&
      formData.workAddress2?.trim() &&
      !errors.workAddress2 &&
      formData.workPincode?.trim() &&
      !errors.workPincode &&
      workCity?.trim() &&
      !errors.workCity &&
      workState?.trim() &&
      !errors.workState;

    setIsFormValid(Boolean(allValid));
  }, [
    formData.addressLine1,
    formData.addressLine2,
    formData.pincode,
    city,
    state,
    formData.workAddress1,
    formData.workAddress2,
    formData.workPincode,
    workCity,
    workState,
    errors,
  ]);

  const validateForm = () => {
    let newErrors = {};

    /* =========================
     Residence Address
  ========================== */

    if (!formData.addressLine1?.trim()) {
      newErrors.addressLine1 = "Required";
    }

    if (!formData.addressLine2?.trim()) {
      newErrors.addressLine2 = "Required";
    }

    if (!formData.pincode || !/^\d{6}$/.test(formData.pincode)) {
      newErrors.pincode = "Enter valid 6-digit pincode";
    }

    /* =========================
     Work Address
  ========================== */

    if (!formData.workAddress1?.trim()) {
      newErrors.workAddress1 = "Required";
    }

    if (!formData.workAddress2?.trim()) {
      newErrors.workAddress2 = "Required";
    }

    if (!formData.workPincode || !/^\d{6}$/.test(formData.workPincode)) {
      newErrors.workPincode = "Enter valid 6-digit pincode";
    }

    /* =========================
     Finalize
  ========================== */

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlePincodeLookup = async ({
    value,
    type, // "residence" | "office"
  }) => {
    value = value.replace(/\D/g, "");

    if (!/^\d{0,6}$/.test(value)) return;
    if (value.length > 0 && value[0] === "0") return;

    if (type === "residence") {
      setFormData((prev) => ({ ...prev, pincode: value }));
    } else {
      setFormData((prev) => ({ ...prev, workPincode: value }));
    }

    if (value.length !== 6) return;

    try {
      const response = await callApi(`v1/util/${value}`, "get", {}, "core");

      if (!response?.success) {
        setErrors((prev) => ({
          ...prev,
          [`${type}Pincode`]: true,
        }));
        return;
      }

      const city1 = response.city || "";
      const state1 = response.state || "";

      if (type === "residence") {
        setCity(city1);
        setState(getStateFromPincode(value) || "");
        setErrors((prev) => ({ ...prev, pincode: false }));
      } else {
        setWorkCity(city1);
        setworkState(getStateFromPincode(value) || "");
        setErrors((prev) => ({ ...prev, workPincode: false }));
      }
    } catch (err) {
      console.error("Pincode lookup failed", err);
      setErrors((prev) => ({
        ...prev,
        [`${type}Pincode`]: true,
      }));
    }
  };

  const handleNext = async () => {
    if (isSubmitting) return; // 🚫 block double click
    if (!validateForm()) return;

    setIsSubmitting(true); // 🔒 lock button

    try {
      // Save to parent state
      setAddressState((prev) => ({
        ...prev,
        address1: formData.addressLine1,
        address2: formData.addressLine2,
        pincode: formData.pincode,
        city,
        state,
        work_address1: formData.workAddress1,
        work_address2: formData.workAddress2,
        workPincode: formData.workPincode,
        workCity,
        workState,
      }));

      await callApi(
        `v1/lead/${leadId}/update-lead-new`,
        "post",
        {
          lead: {
            is_residence_completed: true,
            steps_completed: 4,
            address1: formData.addressLine1 || "",
            address2: formData.addressLine2 || "",
            pincode: formData.pincode || "",
            city,
            state,
            work_address1: formData.workAddress1 || "",
            work_address2: formData.workAddress2 || "",
            work_pincode: formData.workPincode || "",
            work_city: workCity || "",
            work_state: workState || "",
          },
        },
        "core",
        user?.token
      );

      const ltResponse = await callApi(
        "v1/lender_api_call/list",
        "post",
        {
          filters: {
            lead_id: InternalLeadId,
            lender_name: { $in: ["Aditya Birla Capital"] },
          },
          pageSize: 10,
          pageNum: 1,
        },
        "loan_service"
      );

      const lendersData = await callApi(
        "v1/lender/list",
        "post",
        {
          filters: {
            name: { $in: ["Aditya Birla Capital"] },
          },
          pageSize: 10,
          pageNum: 1,
        },
        "loan_service",
        user.token
      );

      const hasLenderCall = (name) =>
        (ltResponse?.data?.lender_api_callList || []).some(
          (entry) => entry.lender_name === name
        );

      const getLenderMeta = (name) =>
        (lendersData?.data?.lenderList || []).find((l) => l.name === name) ||
        null;

      const dmiMeta = getLenderMeta("Aditya Birla Capital");
      let jugadResp;
      if (!hasLenderCall("Aditya Birla Capital") && dmiMeta) {
        await callApi(
          "v1/lead/bulk-lead-push-by-leadId",
          "post",
          {
            leads: [{ lead_id: InternalLeadId }],
            lender_name: "Aditya Birla Capital",
            lender_id: dmiMeta._id,
          },
          "core",
          user.token
        );
        const leadRes = await callApi(
          `v1/lead/list`,
          "post",
          {
            filters: {
              _id: InternalLeadId,
            },
          },
          "core",
          user?.token ||
            "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
        );
        console.log(leadRes.data.leadList[0]);
        const leadData = leadRes?.data?.leadList[0];

        console.log(formData);
        jugadResp = await callApi(
          "v1/lender/test-kb-new",
          "post",
          {
            ...leadData,
            id: InternalLeadId,
          },
          "loan_service",
          user.token
        );
        jugadResp.data.app_url = jugadResp.app_url;
        jugadResp.data.logo_image_url =
          "https://campaigns.digitmoney.in/image/abc.png";
      }

      const pollOffers = async (attempt = 1) => {
        const result = await fetchOffers(InternalLeadId, jugadResp);

        if (result.success && result.offers.length > 0) {
          setHasOffer(true);
        }

        dispatch(
          setAllOffers({
            offers: result.offers,
            failedList: result.failedList,
          })
        );

        if (attempt >= 6) return true;

        return new Promise((resolve) =>
          setTimeout(() => resolve(pollOffers(attempt + 1)), 5000)
        );
      };

      await pollOffers();

      if (hasOffer) {
        await addLead({
          leadId: InternalLeadId,
          lead_type: "live",
          priority: 2,
          stage: "Have offer",
        });
      } else {
        await addLead({
          leadId: InternalLeadId,
          lead_type: "live",
          priority: 2,
          stage: "Professional Details",
        });
        setCurrentStep(5);
      }
    } catch (error) {
      console.error("Submit failed:", error);
    } finally {
      setIsSubmitting(false); // 🔓 unlock button
    }
  };

  return (
    <div className="flex flex-col min-h-[100dvh] font-atkinson w-full pb-2 overflow-hidden max-w-[400px] px-3 px-4-340">
      <Header />
      <h2 className="text-[20px] mt-3 ml-2 mb-2 font-atkinson-bold">
        Residence Address
      </h2>

      <FormInputStyle4
        label="Address Line 1"
        value={formData.addressLine1}
        onChange={handleChange("addressLine1")}
        isValid={!errors.addressLine1}
        error={errors.addressLine1}
      />

      <FormInputStyle4
        label="Address Line 2"
        value={formData.addressLine2}
        onChange={handleChange("addressLine2")}
        isValid={!errors.addressLine2}
        error={errors.addressLine2}
      />

      <FormInputStyle4
        label="Home Pin code"
        value={formData.pincode}
        onChange={(e) =>
          handlePincodeLookup({
            value: e.target.value,
            type: "residence",
          })
        }
        isValid={!errors.pincode}
        errorMessage="Enter valid 6-digit PIN"
        tick={formData.pincode.length === 6 && !errors.pincode}
      />
      <div className="flex gap-3 w-full max-w-[340px] mx-auto">
        <div className="flex-1">
          <FormInputStyle5
            label="City"
            type="text"
            value={city}
            readOnly
            isValid={!errors.city}
            error={errors.city}
          />
        </div>

        <div className="flex-1">
          <FormInputStyle5
            label="State"
            type="text"
            value={state}
            readOnly
            isValid={!errors.state}
            error={errors.state}
            errorMessage="Select a valid state"
          />
        </div>
      </div>

      <h2 className="text-[20px] mt-3 ml-2 mb-2 font-atkinson-bold">
        Office Address
      </h2>
      <FormInputStyle4
        label="Address Line 1"
        value={formData.workAddress1}
        onChange={handleChange("workAddress1")}
        isValid={!errors.workAddress1}
        error={errors.workAddress1}
      />

      <FormInputStyle4
        label="Address Line 2"
        value={formData.workAddress2}
        onChange={handleChange("workAddress2")}
        isValid={!errors.workAddress2}
        error={errors.workAddress2}
      />

      <FormInputStyle4
        label="Office Pin code"
        value={formData.workPincode}
        onChange={(e) =>
          handlePincodeLookup({
            value: e.target.value,
            type: "office",
          })
        }
        isValid={!errors.workPincode}
        errorMessage="Enter valid 6-digit PIN"
        tick={formData.workPincode.length === 6 && !errors.workPincode}
      />

      <div className="flex gap-3 w-full max-w-[340px] mx-auto">
        <div className="flex-1">
          <FormInputStyle5
            label="Work City"
            type="text"
            value={workCity}
            readOnly
            isValid={!errors.workCity}
            error={errors.workCity}
          />
        </div>

        <div className="flex-1">
          <FormInputStyle5
            label="Work State"
            type="text"
            value={workState}
            readOnly={!!workState}
            isValid={!errors.workState}
            error={errors.workState}
            errorMessage="Select a valid state"
          />
        </div>
      </div>
      <FormButtonStyle4
        className="mt-auto mb-3"
        text={isSubmitting ? "Fetching details..." : "Get My Offers"}
        onClick={handleNext}
        disabled={!isFormValid || pincodeValidation || isSubmitting}
      />
    </div>
  );
}